import union from 'lodash/union';

// Creates a reducer managing pagination, given the action types to handle,
// and a function telling how to extract the key from an action.
const paginate = ({ types, resetType = null }) => {
  if (!Array.isArray(types) || types.length !== 3) {
    throw new Error('Expected types to be an array of three elements.')
  }
  if (!types.every(t => typeof t === 'string')) {
    throw new Error('Expected types to be strings.')
  }
  
  const [ requestType, successType, failureType ] = types

  resetType = resetType || 'pagination/RESET';

  const initialState = {
    isFetching: false,
    nextPageUrl: undefined,
    pageCount: 0,
    ids: [],
  };

  const updatePagination = (state = {}, action) => {
    switch (action.type) {
      case requestType:
        return action.reset
        ? {...initialState, isFetching: true }
        : {...state, isFetching: true };

      case successType:
        // Response is normalized
        return {
          ...state,
          isFetching: false,
          ids: union(state.ids, action.response.result),
          nextPageUrl: action.response.next,
          pageCount: state.pageCount + 1
        };

      case failureType:
        return {
          ...state,
          isFetching: false
        }

      default:
        return state
    }
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case requestType:
      case successType:
      case failureType:
        return updatePagination(state, action);
      
      case resetType:
        return initialState;

      default:
        return state
    }
  }
}

export default paginate


// WEBPACK FOOTER //
// ./src/redux/modules/paginate.js